import React from 'react';
import DishCard from '../DishCard';

export default function ZomatoCompactLayout({ 
  filtered, 
  categories, 
  cart, 
  onUpdateQuantity 
}) {
    return (
        <div className="layout-zomato-compact">
            {categories.filter(cat => cat !== 'All').map(cat => {
                const catDishes = filtered.filter(d => d.category === cat);
                if (catDishes.length === 0) return null;
                return (
                    <section key={cat} id={`cat-${cat}`} className="mb-6 pt-2">
                        <h2 className="text-sm font-black text-charcoal mb-3 flex items-center gap-2 uppercase tracking-wide">
                            {cat}
                        </h2>
                        <div className="flex flex-col gap-3">
                            {catDishes.map(dish => (
                                <div key={dish.id}>
                                    <DishCard 
                                        dish={dish} 
                                        quantity={cart[dish.id] || 0} 
                                        onUpdateQuantity={(q, e) => onUpdateQuantity(dish.id, q, e, dish)} 
                                    />
                                </div>
                            ))}
                        </div>
                    </section>
                );
            })}
        </div>
    );
}
